import { render } from "./RecipeCard.vue?vue&type=template&id=7d510109&scoped=true"
import script from "./RecipeCard.vue?vue&type=script&lang=js"
export * from "./RecipeCard.vue?vue&type=script&lang=js"

import "./RecipeCard.vue?vue&type=style&index=0&id=7d510109&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d510109"]])

export default __exports__